import { create } from 'zustand';
import AsyncStorage from '@react-native-async-storage/async-storage';

const STORAGE_KEY = '@drawerMenu:v1';

export const DRAWER_SECTION_KEYS = ['main', 'admin', 'account'];

const DEFAULT_OPEN_STATE = DRAWER_SECTION_KEYS.reduce((acc, key) => {
    acc[key] = true;
    return acc;
}, {});

const initialState = {
    openSections: { ...DEFAULT_OPEN_STATE },
    collapsed: false,
    isHydrated: false,
};

const persist = async (openSections, collapsed) => {
    try {
        await AsyncStorage.setItem(STORAGE_KEY, JSON.stringify({ openSections, collapsed }));
    } catch {
        // silently fail
    }
};

const useDrawerMenuStore = create((set, get) => ({
    ...initialState,

    hydrate: async () => {
        if (get().isHydrated) return;
        try {
            const stored = await AsyncStorage.getItem(STORAGE_KEY);
            if (stored) {
                const parsed = JSON.parse(stored);
                if (parsed && typeof parsed === 'object') {
                    // v1 stored the openSections map at the top level; v2 nests it
                    // under `openSections` alongside `collapsed`. Support both.
                    const storedSections = (parsed.openSections && typeof parsed.openSections === 'object')
                        ? parsed.openSections
                        : parsed;
                    const openSections = { ...DEFAULT_OPEN_STATE };
                    DRAWER_SECTION_KEYS.forEach((key) => {
                        if (typeof storedSections[key] === 'boolean') openSections[key] = storedSections[key];
                    });
                    set({
                        openSections,
                        collapsed: typeof parsed.collapsed === 'boolean' ? parsed.collapsed : false,
                        isHydrated: true,
                    });
                    return;
                }
            }
        } catch {
            // fall back to defaults
        }
        set({ isHydrated: true });
    },

    setSectionOpen: (key, isOpen) => {
        if (!DRAWER_SECTION_KEYS.includes(key)) return;
        const openSections = { ...get().openSections, [key]: isOpen };
        persist(openSections, get().collapsed);
        set({ openSections });
    },

    setCollapsed: (collapsed) => {
        persist(get().openSections, collapsed);
        set({ collapsed });
    },

    toggleSection: (key) => {
        const current = get().openSections[key];
        get().setSectionOpen(key, !current);
    },
}));

export default useDrawerMenuStore;
